import React, { useState } from "react";
import ModalHeader from "../../components/Headers/ModalHeader";
import Table from "../../components/oldTable/Table";
import { SortDirection } from "../../generate";
const columns = [
  {
    label: "Employer Plans within ESI",
    align: "left",
    dataKey: "planName",
  },
  {
    label: "Number of Lives",
    align: "left",
    dataKey: "lives",
  },
];

const PbmModal: React.FC = () => {
  const [sort, setSort] = useState({ field: "plan", direction: SortDirection.Ascending });
  return (
    <div className="max-w-screen-lg">
      <ModalHeader title="Express Scripts (ESI) Employer Plans"></ModalHeader>
      <Table columns={columns} loading={true} disableFooter={true} sort={sort} handleSort={setSort} />
      <p className="mt-4">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
        magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
        consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
        laborum."
      </p>
    </div>
  );
};

export default PbmModal;
